import { h } from '@stencil/core';
export class AibaVtoComponent {
  constructor() {
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.vtoclass = 'showvto';
    this.viewmodel = false;
    this.video = {};
    this.vtoFrameContainerRef = undefined;
  }
  async componentWillLoad() {
    await this.handlers.vtoPreLoad();
  }
  componentDidUpdate() {
    var _a, _b;
    if ((this === null || this === void 0 ? void 0 : this.handlers) && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.vtoCameraDidLoad)) {
      (_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.vtoCameraDidLoad();
    }
  }
  async componentDidLoad() {
    try {
      await this.handlers.setVtoRenderBlock('YMK-module');
      const { VTO_SDK_SDK_PATH, VTO_SDK_API_KEY, ID } = await this.handlers.initateVto();
      const y = document.getElementById('initscript');
      if (!y) {
        const SDK_PATH = VTO_SDK_SDK_PATH + '?apiKey=' + VTO_SDK_API_KEY;
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.id = ID;
        s.async = true;
        s.src = SDK_PATH;
        s.onerror = () => {
          this.handlers.showErrorScreen();
        };
        const x = document.getElementsByTagName('head')[0];
        x.append(s);
      }
      else {
        try {
          window['YMK'].openHairStyle();
        }
        catch (error) {
          this.handlers.showErrorScreen();
        }
      }
      window['ymkAsyncInit'] = async () => {
        if (this.data) {
          let element = document.getElementById('YMK-module');
          const vto = await this.handlers.getVtoConfig();
          let initObject = {
            skinSmoothStrength: vto['skinSmoothStrength'],
            language: vto['language'],
            userConsent: vto['userConsent'],
            width: window.screen.width || window.innerWidth,
            height: (element === null || element === void 0 ? void 0 : element.clientHeight) || window.innerHeight || window.screen.height,
          };
          if (vto['enableWhatsAppSharing'] !== undefined) {
            initObject['enableWhatsAppSharing'] = vto['enableWhatsAppSharing'];
          }
          window['YMK'].init(initObject);
          window['YMK'].openHairStyle();
          window['YMK'].addEventListener('loaded', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventLoaded());
          });
          window['YMK'].addEventListener('consentUIShowed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventConsentUIShowed());
          });
          window['YMK'].addEventListener('disagreeUIShowed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventDisagreeUIShowed());
          });
          window['YMK'].addEventListener('consentUpdated', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventConsentUpdated());
          });
          window['YMK'].addEventListener('cameraClosed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventCameraClosed());
          });
          window['YMK'].addEventListener('cameraFailed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventCameraFailed());
          });
          window['YMK'].addEventListener('cameraOpened', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventCameraOpened());
          });
          window['YMK'].addEventListener('closed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventClosed());
          });
          window['YMK'].addEventListener('engineClosed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventEngineClosed());
          });
          window['YMK'].addEventListener('opened', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventEngineOpened());
          });
          window['YMK'].addEventListener('launcherPageEntered', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventLauncherPageEntered());
          });
          window['YMK'].addEventListener('liveCamIconClicked', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventLiveCamIconClicked());
          });
          window['YMK'].addEventListener('uploadPhotoIconClicked', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventUploadPhotoIconClicked());
          });
          window['YMK'].addEventListener('chooseModelIconClicked', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventChooseModelIconClicked());
          });
          window['YMK'].addEventListener('closed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventClosed());
            window['YMK'].openHairStyle();
          });
          window['YMK'].addEventListener('engineClosed', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventEngineClosed());
            window['YMK'].openHairStyle();
          });
          window['YMK'].addEventListener('uploadPhotoIconClicked', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventUploadPhotoIconClicked());
          });
          window['YMK'].addEventListener('hairStyleChanged', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventHairStyleChanged(report));
          });
          window['YMK'].addEventListener('backIconClicked', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventBackIconClicked(report));
          });
          window['YMK'].addEventListener('readyButtonClicked', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventReadyButtonClicked(report));
          });
          window['YMK'].addEventListener('closeIconClicked', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventCloseIconClicked(report));
          });
          window['YMK'].addEventListener('flipCamera', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventFlipCamera(report));
          });
          window['YMK'].addEventListener('retakePhoto', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventRetakePhoto(report));
          });
          window['YMK'].addEventListener('keepPhoto', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventKeepPhoto(report));
          });
          window['YMK'].addEventListener('confirmExit', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventConfirmExit(report));
          });
          window['YMK'].addEventListener('photoSaved', async () => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventPhotoSaved());
          });
          window['YMK'].addEventListener('cancelExit', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventCancelExit(report));
          });
          window['YMK'].addEventListener('inaccessibleCameraGotIt', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventInaccessibleCameraGotIt(report));
          });
          window['YMK'].addEventListener('photoCaptured', async (report) => {
            var _a;
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.setVtoEventPhotoCaptured(report));
          });
          window['YMK'].addEventListener('readyToGenerate', async (report) => {
            var _a;
            console.log('Ready to generate======', report);
            await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.vtoReadyHandler());
          });
        }
      };
    }
    catch (error) {
      this.handlers.showErrorScreen();
    }
  }
  async closeYMKModule() {
    await this.handlers.vtoCloseYMKModule();
  }
  async closeModel() {
    await this.handlers.vtoCloseModel();
  }
  render() {
    return h("div", { class: `frameContainer ${this.vtoclass}`, ref: el => (this.vtoFrameContainerRef = el) });
  }
  static get is() { return "aiba-vto-camera"; }
  static get originalStyleUrls() {
    return {
      "$": ["./aiba-vto-camera.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-vto-camera.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "vtoclass": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vtoclass",
        "reflect": false,
        "defaultValue": "'showvto'"
      }
    };
  }
  static get states() {
    return {
      "viewmodel": {},
      "video": {},
      "vtoFrameContainerRef": {}
    };
  }
  static get events() {
    return [{
        "method": "vtoReadyToGenerate",
        "name": "vtoReadyToGenerate",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-vto-camera.js.map
